export default{
    CREATE_CATEGORY(state, payload){
        state.elearncategory = payload;
    },
    GET_CATEGORY_DATA(state, payload){
        state.elearncategoryData = payload;
    },
    GET_CATEGORY_DATA_LIST(state, payload){
        state.categoryList = payload;
    },
}